import { render } from "./right-nav-component.vue?vue&type=template&id=d523e26e&ts=true"
import script from "./right-nav-component.vue?vue&type=script&lang=ts"
export * from "./right-nav-component.vue?vue&type=script&lang=ts"

import "./right-nav-component.vue?vue&type=style&index=0&id=d523e26e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__